<p-dialog
  styleClass="bg-white p-0 rounded-xl box-border max-h-[80vh] overflow-y-auto w-[90vw] md:w-[40vw]"
  [closable]="false"
  [visible]="visible"
  [modal]="true">
  <ng-template pTemplate="header">
    {{ "terminationConditions.title" | translate }}
  </ng-template>
  <ng-template pTemplate="message">
    <div class="text-sm flex flex-col justify-center items-center rounded-md text-left">
      <p class="pr-1 pl-1">{{ "terminationConditions.intro" | translate }}</p>
      <p-accordion
        class="mt-4"
        [expandIcon]="'pi pi-chevron-down'"
        [collapseIcon]="'pi pi-chevron-up'">
        <!-- How to Request Termination -->
        <p-accordionTab
          headerStyleClass="pr-1 pl-2 pt-3 pb-3 mb-2"
          contentStyleClass="pr-1 pl-2"
          tabStyleClass="mb-4 text-sm"
          header="{{ 'terminationConditions.howToRequestTermination.title' | translate }}">
          <p>
            {{ "terminationConditions.howToRequestTermination.content" | translate }}
          </p>
        </p-accordionTab>

        <!-- Consequences of Termination -->
        <p-accordionTab
          headerStyleClass="pr-1 pl-2 pt-3 pb-3 mb-2"
          contentStyleClass="pr-1 pl-2"
          tabStyleClass="mb-4 text-sm"
          header="{{ 'terminationConditions.consequencesOfTermination.title' | translate }}">
          <p>
            {{ "terminationConditions.consequencesOfTermination.content" | translate }}
          </p>
        </p-accordionTab>

        <!-- Refund of Premiums -->
        <p-accordionTab
          headerStyleClass="pr-1 pl-2 pt-3 pb-3 mb-2"
          contentStyleClass="pr-1 pl-2"
          tabStyleClass="mb-4 text-sm"
          header="{{ 'terminationConditions.refundOfPremiums.title' | translate }}">
          <p>
            {{ "terminationConditions.refundOfPremiums.content" | translate }}
          </p>
        </p-accordionTab>

        <!-- Termination Cases -->
        <p-accordionTab
          headerStyleClass="pr-1 pl-2 pt-3 pb-3 mb-2"
          contentStyleClass="pr-1 pl-2"
          tabStyleClass="mb-4 text-sm"
          header="{{ 'terminationConditions.terminationCases.title' | translate }}">
          <ul class="space-y-2">
            <!-- Added vertical spacing between list items -->
            <li>
              <strong> {{ "terminationConditions.terminationCases.cases.moving.title" | translate }}: </strong>
              {{ "terminationConditions.terminationCases.cases.moving.content" | translate }}
            </li>
            <li>
              <strong>
                {{ "terminationConditions.terminationCases.cases.propertyTransfer.title" | translate }}:
              </strong>
              {{ "terminationConditions.terminationCases.cases.propertyTransfer.content" | translate }}
            </li>
            <li>
              <strong>
                {{ "terminationConditions.terminationCases.cases.personalSituationChange.title" | translate }}:
              </strong>
              {{ "terminationConditions.terminationCases.cases.personalSituationChange.content" | translate }}
            </li>
            <li>
              <strong> {{ "terminationConditions.terminationCases.cases.afterFirstYear.title" | translate }}: </strong>
              {{ "terminationConditions.terminationCases.cases.afterFirstYear.content" | translate }}
            </li>
            <li>
              <strong>
                {{ "terminationConditions.terminationCases.cases.contractExpiration.title" | translate }}:
              </strong>
              {{ "terminationConditions.terminationCases.cases.contractExpiration.content" | translate }}
            </li>
            <li>
              <strong> {{ "terminationConditions.terminationCases.cases.otherReasons.title" | translate }}: </strong>
              {{ "terminationConditions.terminationCases.cases.otherReasons.content" | translate }}
            </li>
          </ul>
        </p-accordionTab>

        <!-- Renter Note -->
        <p-accordionTab
          headerStyleClass="pr-1 pl-2 pt-3 pb-3 mb-2"
          contentStyleClass="pr-1 pl-2"
          tabStyleClass="mb-4 text-sm"
          header="{{ 'terminationConditions.terminationCases.cases.renterNote.title' | translate }}">
          <p>
            {{ "terminationConditions.terminationCases.cases.renterNote.content" | translate }}
          </p>
        </p-accordionTab>
      </p-accordion>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button
      pButton
      [label]="'terminationConditions.CloseButton' | translate"
      (click)="closePopup()"
      class="max-w-[300px] w-full bg-primary text-white h-12 mx-auto block"></button>
  </ng-template>
</p-dialog>
